var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"mr-6",attrs:{"color":"info","disabled":_vm.loading,"loading":_vm.loading,"outlined":""},on:{"click":function($event){return _vm.downloadAsCSV()}}},[_vm._v(" CSV ")])
}
var staticRenderFns = []

export { render, staticRenderFns }